import Swiper from 'swiper/bundle'
import { Navigation, Pagination } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export default class Kv {
    constructor() {
        this.init()
    }

    init() {
        this.kv = document.querySelector('.js-kv')
        this.item = [...document.querySelectorAll('.js-kv-item')]
        this.itemnum = this.item.length

        this.kvSwiper()
        this.hideObj()

        window.addEventListener('load', this.introIn)
    }

    introIn() {
        document.body.setAttribute('data-intro', '1')
        const chara = document.querySelector('.js-kv-chara-8')

        chara.addEventListener('animationend', () => {
            document.body.classList.add('-introend')
        })
    }

    kvSwiper() {
        const swipercont = document.querySelector('.js-kv-swiper')
        const pagenation = document.querySelector('.js-kv-pagination')
        const pnbtnnext = document.querySelector('.js-kv-pnbtn.-next')
        const pnbtnprev = document.querySelector('.js-kv-pnbtn.-prev')

        var isClassAdded = false;

        const option = {
            modules: [Navigation, Pagination],
            autoplay: { delay: 6000, disableOnInteraction: false },
            loop: true,
            speed: 300,
            pagination: { el: pagenation, clickable: true },
            navigation: {
                nextEl: pnbtnnext,
                prevEl: pnbtnprev,
            },
            on: {
                slideChangeTransitionEnd: function () {
                    if (!isClassAdded) {
                        swipercont.classList.add('-slideend')
                        if (!document.body.classList.contains('-introend')) {
                            document.body.classList.add('-introend')
                        }
                        isClassAdded = true
                    }
                },
            },
        }

        const swiper = new Swiper('.js-kv-swiper', option)
    }

    hideObj() {
        if (this.itemnum === 1) {
            document.body.classList.add('-hidekv')
        }
    }
}
